/**
 * CSP相关通信管理器
 * 用于解决大华播放器与百度iframe之间的通信问题
 */

/**
 * 安全地向iframe发送信息，不触发CSP错误
 * @param {HTMLIFrameElement} iframe 目标iframe
 * @param {Object} data 要发送的数据
 * @param {string} targetOrigin 目标源，默认为"*"
 */
export function postMessageSafely(iframe, data, targetOrigin = "*") {
  try {
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(data, targetOrigin);
    }
  } catch (error) {
    console.warn('Error posting message to iframe:', error);
  }
}

/**
 * 为百度iframe添加CSP友好的通信链接
 * @param {HTMLIFrameElement} iframe 百度iframe元素
 */
export function setupBaiduIframeComm(iframe) {
  if (!iframe) return;
  
  // 设置安全的iframe属性
  iframe.setAttribute('allow', 'fullscreen');
  
  // 添加postMessage监听器，处理来自iframe的信息
  window.addEventListener('message', (event) => {
    console.warn('event',event)
    // 验证来源（可选）
    // if (event.origin !== "https://chat.baidu.com") return;
    
    if (event.data && event.data.type === 'BAIDU_IFRAME_CSP_REQUEST') {
      // 百度iframe请求某些操作
      handleBaiduIframeRequest(event.data, iframe);
    }
  });
  
  // 向iframe发送初始化信息
  setTimeout(() => {
    postMessageSafely(iframe, {
      type: 'DHPLAYER_INIT',
      allowCommunication: true
    });
  }, 1000);
}

/**
 * 处理来自百度iframe的请求
 * @param {Object} requestData 请求数据
 * @param {HTMLIFrameElement} sourceIframe 源iframe
 */
function handleBaiduIframeRequest(requestData, sourceIframe) {
  // 根据请求类型处理不同操作
  switch (requestData.action) {
    case 'QUERY_CSP_STATUS':
      // 回复CSP状态查询
      postMessageSafely(sourceIframe, {
        type: 'DHPLAYER_RESPONSE',
        action: 'CSP_STATUS',
        cspEnabled: true,
        allowsFrameAncestors: true
      });
      break;
      
    case 'REQUEST_PAUSE_PLAYER':
      // 暂停大华播放器，避免冲突
      // 这需要实际调用播放器的暂停方法
      document.dispatchEvent(new CustomEvent('dh-player-pause-request'));
      postMessageSafely(sourceIframe, {
        type: 'DHPLAYER_RESPONSE',
        action: 'PLAYER_PAUSED',
        success: true
      });
      break;
      
    default:
      console.warn('Unknown request from Baidu iframe:', requestData);
  }
}

/**
 * 创建一个代理iframe以解决CSP问题
 * @param {string} targetUrl 目标URL
 * @returns {HTMLIFrameElement} 创建的代理iframe
 */
export function createProxyIframe(targetUrl) {
  // 创建一个代理iframe
  const proxyIframe = document.createElement('iframe');
  proxyIframe.style.display = 'none';
  proxyIframe.setAttribute('sandbox', 'allow-scripts allow-same-origin');
  document.body.appendChild(proxyIframe);
  
  // 设置代理内容
  const proxyContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta http-equiv="Content-Security-Policy" content="default-src 'self'; frame-ancestors 'self' *">
      <script>
        window.addEventListener('message', function(event) {
          // 转发消息到目标
          const iframe = document.getElementById('targetFrame');
          if (iframe && iframe.contentWindow) {
            try {
              iframe.contentWindow.postMessage(event.data, '*');
            } catch(e) {
              console.error('Error forwarding message:', e);
            }
          }
        });
        
        // 从目标接收消息并转发回父窗口
        window.addEventListener('message', function(event) {
          if (event.source === document.getElementById('targetFrame').contentWindow) {
            window.parent.postMessage(event.data, '*');
          }
        });
      </script>
    </head>
    <body>
      <iframe id="targetFrame" src="${targetUrl}" style="width:100%;height:100%;border:none;"></iframe>
    </body>
    </html>
  `;
  
  // 写入代理内容
  try {
    const doc = proxyIframe.contentDocument || proxyIframe.contentWindow.document;
    doc.open();
    doc.write(proxyContent);
    doc.close();
  } catch (e) {
    console.error('Error setting up proxy iframe:', e);
  }
  
  return proxyIframe;
}

export default {
  postMessageSafely,
  setupBaiduIframeComm,
  createProxyIframe
}; 